export const MAX_PHONE_EXTENSION_LENGTH = 11;

export const sanitizePhoneExtension = (value: string): string =>
  value.replace(/[^0-9*#]/g, '').slice(0, MAX_PHONE_EXTENSION_LENGTH);
